import type { JSX, PropsWithChildren } from "react";
import { Button } from "@/shared/ui";
import { CardWrapper } from "../card-wrapper";

interface StepCardProps extends PropsWithChildren {
  title: string;
  subtitle?: string | JSX.Element;
  onSubmit?: (e: any) => void;
  onClickBack?: () => void;
  className?: string;
  disabledBackBtn?: boolean;
  disabledSubmitBtn?: boolean;
  headerControl?: React.ReactNode;
  hideFooter?: boolean;
  isLoadingSubmit?: boolean;
  isLoadingBack?: boolean;
  error?: string;
  assessedFirstName?: string;
  assessedLastName?: string;
  assessedRole?: string;
  stepCurrent?: number;
  stepsTotal?: number;
}

export const StepCard = (props: StepCardProps): JSX.Element => {
  const {
    title,
    subtitle,
    children,
    onClickBack,
    onSubmit,
    className,
    disabledBackBtn,
    headerControl,
    disabledSubmitBtn,
    hideFooter = false,
    isLoadingSubmit = false,
    isLoadingBack = false,
    error,
    assessedFirstName,
    assessedLastName,
    assessedRole,
    stepCurrent,
    stepsTotal,
  } = props;

  const submitHandler = (e: any) => {
    e.preventDefault();

    if (!isLoadingSubmit) onSubmit?.(e);
  };

  return (
    <CardWrapper
      classNames={{ wrapper: className }}
      title={title}
      subtitle={subtitle}
      headerControl={headerControl}
      assessedFirstName={assessedFirstName}
      assessedLastName={assessedLastName}
      assessedRole={assessedRole}
      stepCurrent={stepCurrent}
      stepsTotal={stepsTotal}
    >
      <form onSubmit={submitHandler} className="flex flex-col items-start gap-8">
        <div className="w-full pt-5">{children}</div>
        {!hideFooter && (
          <footer className="border-background-grey flex w-full items-center gap-6 border-t-[2px] p-[40px]">
            <div className="flex shrink-0 gap-3">
              {onClickBack && (
                <Button
                  onClick={() => !isLoadingBack && onClickBack()}
                  disabled={disabledBackBtn || isLoadingBack}
                  size="lg"
                  appearance="secondary"
                  className="!h-full w-[130px] !border-none bg-[#F1F1F1] !px-0 !py-5 text-center font-semibold text-[212529] disabled:border-[#E2E2E2] disabled:bg-[#E2E2E2] disabled:text-[#AFAFAF]!"
                  isLoading={isLoadingBack}
                >
                  Go Back
                </Button>
              )}
              <Button
                disabled={disabledSubmitBtn || isLoadingSubmit}
                type="submit"
                size="sm"
                appearance="primary"
                className="!h-full w-[130px] !border-none !px-0 !py-5 text-center font-semibold disabled:border-[#E2E2E2] disabled:bg-[#E2E2E2] disabled:text-[#AFAFAF]!"
                isLoading={isLoadingSubmit}
              >
                Continue
              </Button>
            </div>
            {error && <p className="font-family-third text-base font-medium text-[#EC221F]">{error}</p>}
          </footer>
        )}
      </form>
    </CardWrapper>
  );
};
